<template>
    <div class="loader">
        <div class="LoaderBalls">
            <div class="LoaderBalls__item"><img src="../assets/logo.png" alt="DIF" height="100%" width="100%"></div>
            <div class="LoaderBalls__item"><img src="../assets/logo.png" alt="DIF" height="100%" width="100%"></div>
            <div class="LoaderBalls__item"><img src="../assets/logo.png" alt="DIF" height="100%" width="100%"></div>
        </div>
        <div>
            <p>Cargando...</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Loader'
}
</script>

<style>
.loader {
  width: 250px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #383838c4;
  border-radius: 5px;
}
 .loader p {
     color: white;
     font-size: 14px;
     font-weight: bold;
     padding-top:20px;
 }
.LoaderBalls {
  width: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top:20px;
}
.LoaderBalls__item {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #2EBAB0;
}
.LoaderBalls__item:nth-child(1) {
  animation: bouncing 0.4s alternate infinite cubic-bezier(0.6, 0.05, 0.15, 0.95);
}
.LoaderBalls__item:nth-child(2) {
  animation: bouncing 0.4s 0.1s alternate infinite cubic-bezier(0.6, 0.05, 0.15, 0.95) backwards;
}
.LoaderBalls__item:nth-child(3) {
  animation: bouncing 0.4s 0.2s alternate infinite cubic-bezier(0.6, 0.05, 0.15, 0.95) backwards;
}

@keyframes bouncing {
  0% {
    transform: translate3d(0, 10px, 0) scale(1.2, 0.85);
  }
  100% {
    transform: translate3d(0, -20px, 0) scale(0.9, 1.1);
  }
}

</style>
